import { AfterContentInit, Component, ContentChildren, OnDestroy, QueryList, ViewChild, ViewEncapsulation } from '@angular/core';
import { SideDrawerComponent } from './side-drawer/side-drawer.component';
import { MatDrawer } from '@angular/material/sidenav';
import { Subscription } from 'rxjs';

@Component({
    selector: 'tt-side-drawer-container',
    templateUrl: './side-drawer-container.component.html',
    styleUrls: ['./side-drawer-container.component.css'],
    encapsulation: ViewEncapsulation.None,
})
export class SideDrawerContainerComponent implements AfterContentInit, OnDestroy {
    @ViewChild('startMatDrawer')
    public set startMatDrawer(drawer: MatDrawer | undefined) {
        this._startMatDrawer = drawer;
        if (drawer && this.startDrawer) void this.startDrawer.setMatDrawerRef(drawer);
    }
    public get startMatDrawer(): MatDrawer | undefined {
        return this._startMatDrawer;
    }
    private _startMatDrawer?: MatDrawer;

    @ViewChild('endMatDrawer')
    public set endMatDrawer(drawer: MatDrawer | undefined) {
        this._endMatDrawer = drawer;
        if (drawer && this.endDrawer) void this.endDrawer.setMatDrawerRef(drawer);
    }
    public get endMatDrawer(): MatDrawer | undefined {
        return this._endMatDrawer;
    }
    private _endMatDrawer?: MatDrawer;

    @ContentChildren(SideDrawerComponent, { descendants: true })
    public drawers!: QueryList<SideDrawerComponent>;

    public startDrawer?: SideDrawerComponent;

    public endDrawer?: SideDrawerComponent;

    private drawersSubscription?: Subscription;

    ngAfterContentInit(): void {
        this.setDrawers();
        this.drawersSubscription = this.drawers.changes.subscribe(() => this.setDrawers());
    }

    ngOnDestroy(): void {
        this.drawersSubscription?.unsubscribe();
    }

    private setDrawers(): void {
        this.startDrawer = this.drawers.find((drawer) => drawer.ttPosition !== 'end');
        this.endDrawer = this.drawers.find((drawer) => drawer.ttPosition === 'end');
    }
}
